export default __webpack_public_path__ + "static/media/sales.027dd465.svg";